import React from 'react'
import {
  Modal
} from 'antd-mobile';
import './shareShadeLayer.less'

export default class ShareShadeLayer extends React.Component {
  constructor(props) {
    super(props)
  }

  onClose = () => {
    this.props.onShow()
  }

  render() {
    const { wxShareVisible } = this.props;
    return (
      <Modal
        popup
        className="sound-share-shade-layer-modal"
        visible={wxShareVisible}
        animationType="slide-down"
        onClose={this.onClose}
      >
        <div className="wxshare-modal-container">
          <div className="wxshare-arrow">
            <img src={require('../../images/share_wechat_arrow.png')} alt="" />
          </div>
        </div>
      </Modal>
    );
  }
}